module.exports = __webpack_public_path__ + "images/boatyard_logo_diversified.255ccf95f24b19b37dfa1407910c395c.png";